import { get } from 'lodash';

import Model from 'models';

const PageSectionLifestyleCollectionsModel = class extends Model {
  get internalName() {
    return get(this, ['_data', 'internalName']);
  }

  get items() {
    return get(this, ['_data', 'items'], []);
  }

  get type() {
    return get(this, ['_data', '_contentType']);
  }
};

export default PageSectionLifestyleCollectionsModel;
